export enum DeviceTypeEnum {
  huanghe1 = 1,
  huanghe2 = 3,
  huanghe3 = 4,
  adas = 5,
  kunlunshan1 = 2,
  kunlunshan2 = 6,
  kunlunshan3 = 7,
  huanghe4 = 8,
  kunlunshan4 = 9,
  adas1 = 10,
  adas2 = 11,
  adas3 = 12,
  kunlunshan5 = 13,
  junchi1 = 14,
  new1 = 15,
  new2 = 16,
  new3 = 17,
  changxing = 20,
  lingxing = 21,
  changxing54 = 22,
  changxing56 = 23,
  jimu = 24,
  changxingA1001 = 25,
  changxingA2001 = 26,
  changxing50A2 = 27,
  changxing54A2 = 28,
  changxing56A2 = 29,
  lingxingB2 = 30,
  TLY5C1 = 31,
  TLY5D2001 = 32,
  TLY5D2002 = 33,
  // TLY5.0A3 暂用 34，后续以后端最终枚举值为准调整。
  TLY50A3 = 34,
  TLY50F4001 = 35,
}

export interface DeviceType {
  label: string;
  value: Number;
}
export interface stateType {
  label: string;
  value: string;
}

// 车辆类型
export const carTypeData: Array<DeviceType> = [
  { label: '自卸车', value: 1 },
  { label: '牵引车', value: 2 },
  { label: '商砼车', value: 3 },
  { label: '消防车', value: 4 },
  { label: '拖车', value: 5 },
  { label: '未确认', value: 6 },
  { label: '货车', value: 7 },
];

// 设备类型数据
export const deviceTypeData: Array<DeviceType> = [
  { label: 'TLY0.6', value: DeviceTypeEnum.new1 },//15
  { label: 'TLY1.1', value: DeviceTypeEnum.huanghe1 }, //1
  { label: 'TLY1.2', value: DeviceTypeEnum.huanghe2 }, //3
  { label: 'TLY1.3', value: DeviceTypeEnum.huanghe3 },//4
  { label: 'TLY1.4', value: DeviceTypeEnum.huanghe4 },//8
  { label: 'TLY1.6', value: DeviceTypeEnum.new2 },//16
  { label: 'TLY2.0', value: DeviceTypeEnum.kunlunshan1 },//2
  { label: 'TLY2.2', value: DeviceTypeEnum.kunlunshan2 },//6
  { label: 'TLY2.3', value: DeviceTypeEnum.kunlunshan3 },//7
  { label: 'TLY2.4', value: DeviceTypeEnum.kunlunshan4 },//9
  { label: 'TLY0.5', value: DeviceTypeEnum.adas },//5
  { label: 'TLY0.4', value: DeviceTypeEnum.adas1 },//10
  { label: '博富CBS2.0', value: DeviceTypeEnum.adas2 },//11
  { label: 'TLY3.6', value: DeviceTypeEnum.new3 },//17
  { label: 'TLY3.4', value: DeviceTypeEnum.adas3 },//12
  { label: 'TLY3.0', value: DeviceTypeEnum.kunlunshan5 },//13
  { label: 'TLY4.0', value: DeviceTypeEnum.junchi1 },//14
  { label: 'TLY5.0A1', value: DeviceTypeEnum.changxing },//20
  { label: 'TLY5.0B1', value: DeviceTypeEnum.lingxing },//21
  { label: 'TLY5.0B2', value: DeviceTypeEnum.lingxingB2 },//30
  { label: 'TLY5.4A1', value: DeviceTypeEnum.changxing54 },//22
  { label: 'TLY5.6A1', value: DeviceTypeEnum.changxing56 },//23
  { label: 'TLY6.0', value: DeviceTypeEnum.jimu },//24
  { label: 'TLY5.0A1-001', value: DeviceTypeEnum.changxingA1001 },//25
  { label: 'TLY5.0A2-001', value: DeviceTypeEnum.changxingA2001 },//26
  { label: 'TLY5.0A2', value: DeviceTypeEnum.changxing50A2 },//27
  { label: 'TLY5.4A2', value: DeviceTypeEnum.changxing54A2 },//28
  { label: 'TLY5.6A2', value: DeviceTypeEnum.changxing56A2 },//29
  { label: 'TLY5.0C1', value: DeviceTypeEnum.TLY5C1 },
  { label: 'TLY5.0D2-001', value: DeviceTypeEnum.TLY5D2001 },
  { label: 'TLY5.0D2-002', value: DeviceTypeEnum.TLY5D2002 },
  { label: 'TLY5.0A3', value: DeviceTypeEnum.TLY50A3 },
  { label: 'TLY-5.0F4-001', value: DeviceTypeEnum.TLY50F4001 },

];

// 硬件配置类型
export const deviceConfigData: Array<DeviceType> = [
  { label: '行车记录仪', value: 1 },
  { label: '声光报警器', value: 2 },
  { label: '前毫米波', value: 3 },
  { label: '超声波雷达', value: 4 },
  { label: 'IMU', value: 5 },
  { label: '右角雷达', value: 6 },
  { label: '爆闪灯', value: 7 },
];

// export const aebDeviceTypeData = [
//   {label:'黄河设备',value:1},
//   {label:'昆仑山设备',value:2},
//   {label:'部标机设备',value:3},
// ]
// 车辆类型
export const carType = (value: any) => {
  if (value == 1) {
    return '自卸车'
  } else if (value == 2) {
    return '牵引车'
  } else if (value == 3) {
    return '商砼车'
  } else if (value == 4) {
    return '消防车'
  } else if (value == 5) {
    return '拖车'
  } else if (value == 7) {
    return '货车'
  }
}


// 车辆状态
export const carState: Array<stateType> = [
  { label: '正常', value: '正常' },
  { label: '停用', value: '停用' },
  { label: '故障', value: '故障' },
];
// 设备状态
export const deviceState: Array<stateType> = [
  { label: '正常', value: '正常' },
  { label: '停用', value: '停用' },
  { label: '故障', value: '故障' },
];
// 设备类型大类
export enum DeviceCategoryEnum {
  huanghe = 1,
  kunlunshan = 2,
  kunlunshanV3 = 3,
  changxing = 4,
  adas = 5,
  lingxing = 6,
}

// 设备类型大类数据
export const deviceCategoryData: Array<DeviceType> = [
  { label: '黄河设备', value: DeviceCategoryEnum.huanghe },
  { label: '昆仑山设备', value: DeviceCategoryEnum.kunlunshan },
  { label: '昆仑山3.0设备', value: DeviceCategoryEnum.kunlunshanV3 },
  { label: '视频机', value: DeviceCategoryEnum.adas },
  { label: '畅行1.0', value: DeviceCategoryEnum.changxing },
  { label: '领行', value: DeviceCategoryEnum.lingxing }
];

export const devicveDelStatusData: Array<{ [key: string]: string }> = [
  { label: '卖车拆除', value: '卖车拆除' },
  { label: '拒保拆除', value: '拒保拆除' },
  { label: '迁移拆除', value: '迁移拆除' },
  { label: '满期拆除', value: '满期拆除' },
  { label: '退出拆除', value: '退出拆除' },
  { label: '其它拆除', value: '其它拆除' },
];


//子设备种类
//下发参数的时候设备类型id用的也是这个
export enum SubDeviceTypeEnum {
  // 前向一体机 - 多来目供应商
  forwardIntegratedMachine_duolaimu = 1,
  // 前向一体机 - 相机 - 园之云供应商
  forwardIntegratedMachine_camera_yuanzhiyun = 2,
  // 前向一体机 - 雷达 - 园之云供应商
  forwardIntegratedMachine_radar_yuanzhiyun = 3,
  // 拉线电机- 天车自动王
  wireMotor = 4,
  // 5：组合惯导-维特；
  ins_wit = 5,
  // 6：组合惯导-阿奇INS620
  ins_aqi = 6,
  //7 bsd激光雷达
  bsd_laser_radar = 7,
  // 黄河双目相机，当前仅作为 TLY5.0A3 子设备占位，不展示标定数据也不支持下发。
  forwardIntegratedMachine_camera_huanghe = 8,
  // 9：安行前向相机。参数配置下发弹窗不回显字段，以「触发 前视相机自动标定」下发 success=0。
  ax_forward_camera = 9,
  // 10：安行前向毫米波雷达
  ax_forward_mmw_radar = 10,
  // 11：安行DMS相机
  ax_dms_camera = 11,
  // 12：安行BSD相机
  ax_bsd_camera = 12,
  //13-255 预留
}

//根据设备类型获取领行畅行设备安装的子设备类型
export const getLxCxSubDeviceTypesByDeviceType = (deviceType?: DeviceTypeEnum): Array<SubDeviceTypeEnum> => {
  switch (deviceType) {
    // 领行设备 - 返回园之云前向一体机和拉线电机
    case DeviceTypeEnum.lingxing:
    case DeviceTypeEnum.lingxingB2:
      return [
        SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun,
        SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun,
        SubDeviceTypeEnum.wireMotor,
        SubDeviceTypeEnum.ins_aqi,
      ];

    // 畅行设备 - A1系列：返回多来目一体机和拉线电机
    case DeviceTypeEnum.changxing: // TLY5.0A1
    case DeviceTypeEnum.changxing54: // TLY5.4A1
    case DeviceTypeEnum.changxing56: // TLY5.6A1
    case DeviceTypeEnum.changxingA1001: // TLY5.0A1-001
      return [
        SubDeviceTypeEnum.forwardIntegratedMachine_duolaimu,
        SubDeviceTypeEnum.wireMotor,
        SubDeviceTypeEnum.ins_aqi,
      ];

    // 畅行设备 - A2系列：返回园之云前向一体机和拉线电机
    case DeviceTypeEnum.changxingA2001: // TLY5.0A2-001
    case DeviceTypeEnum.changxing50A2: // TLY5.0A2
    case DeviceTypeEnum.changxing54A2: // TLY5.4A2
    case DeviceTypeEnum.changxing56A2: // TLY5.6A2
      return [
        SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun,
        SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun,
        SubDeviceTypeEnum.wireMotor,
        SubDeviceTypeEnum.ins_aqi,
      ];

    // 畅行设备 - A3系列：黄河双目相机暂不展示标定数据、不支持下发
    case DeviceTypeEnum.TLY50A3: // TLY5.0A3
      return [
        SubDeviceTypeEnum.forwardIntegratedMachine_camera_huanghe,
        SubDeviceTypeEnum.wireMotor,
        SubDeviceTypeEnum.ins_aqi,
      ];

    // 畅行设备 - D2系列：返回园之云前向一体机、拉线电机和BSD激光雷达
    case DeviceTypeEnum.TLY5D2001:
    case DeviceTypeEnum.TLY5D2002:
      return [
        SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun,
        SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun,
        SubDeviceTypeEnum.wireMotor,
        SubDeviceTypeEnum.ins_aqi,
        SubDeviceTypeEnum.bsd_laser_radar,
      ];

    // 安行设备：前向相机、前向毫米波雷达、DMS相机、BSD相机、拉线电机、阿奇组合惯导
    case DeviceTypeEnum.TLY50F4001:
      return [
        SubDeviceTypeEnum.ax_forward_camera,
        SubDeviceTypeEnum.ax_forward_mmw_radar,
        SubDeviceTypeEnum.ax_dms_camera,
        SubDeviceTypeEnum.ax_bsd_camera,
        SubDeviceTypeEnum.wireMotor,
        SubDeviceTypeEnum.ins_aqi,
      ];

    default:
      return [];
  }
};
